<template>
  <top-navbar />
  <div
    class="filters-container flex space-y-8 flex-col items-center md:flex-row md:items-start md:space-y-0"
  >
    <div>
      <span ref="filterBtn" @click="showFilters = !showFilters">
        <img
          src="@/assets/images/ic-filter-btn.svg"
          alt=""
          class="filter-btn"
        />
      </span>
    </div>
    <filters-section
      v-if="showFilters"
      class="filter-section"
      @show-section="catchEvent"
    />
    <filters-results />
  </div>
  <filter-description />
  <basic-footer />
</template>

<script setup>
import { useStatsStore } from "@/stores/modules/stats";
import { useUserStore } from "@/stores/modules/user";

import TopNavbar from "@/components/general/ui/navbar/TopNavbar";
import BasicFooter from "@/components/general/ui/footer/BasicFooter";
import FiltersSection from "@/components/wegow/filters/FiltersSection";
import FiltersResults from "@/components/wegow/filters/FiltersResults";
import FilterDescription from "@/components/wegow/filters/FilterDescription";

import { ref, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

const showFilters = ref(false);
const filterBtn = ref(null); // 1. referencia al botón
const route = useRoute();
const { t } = useI18n();

const statsStore = useStatsStore();
const userStore = useUserStore();

onMounted(async () => {
  showFilters.value = window.innerWidth > 769;
  window.addEventListener("resize", handleResize);
  await sendStats();

  if (window.innerWidth <= 768 && filterBtn.value) {
    showFilters.value = true;
    setTimeout(() => {
      showFilters.value = false;
    }, 1);
  }
});
onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});

const handleResize = () => {
  showFilters.value = window.innerWidth > 769;
};

const sendStats = async () => {
  // Enviamos los datos para las stats
  const params = {
    campaign: "page_view",
    id: userStore.userDetail.unsubscribe_token
      ? userStore.userDetail.unsubscribe_token
      : sessionStorage.tt_sessionId,
    uri: route.fullPath,
    pageName: route.name
  };
  if (!window.location.href.includes("wegowlocal")) {
    await statsStore.sendToStatsService(params);
  }
};

const catchEvent = show => {
  showFilters.value = show;
};
</script>

<style lang="scss" scoped>
.filter-btn {
  position: fixed;
  display: none;
  top: 14%;
  right: 10%;
  z-index: 2;
}
@media screen and (max-width: 768px) {
  .filter-btn {
    display: inline-block;
  }
  .filter-section {
    position: fixed;
    top: 20%;
    width: 100%;
    z-index: 2;
    padding-bottom: 200px;
  }
}
.filters-container {
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 75px;
}
@media screen and (min-width: 1000px) {
  .filters-container {
    margin: 100px;
  }
}
@media screen and (min-width: 1400px) {
  .filters-container {
    margin-left: 170px;
  }
}
</style>
